



















import { Component, Vue, Prop } from 'vue-property-decorator'
import Speaker from '@/components/organization/Speaker.vue'

@Component({
  components: {
    Speaker
  }
})
export default class Speakers extends Vue {
  @Prop(Array) private speakers: any
  @Prop(Number) private paginate: number

  private speakersPaginated: any = null

  constructor() {
    super()

    if (!this.paginate) this.paginate = 2

    if (this.paginate) {
      let pages =
        ((this.speakers.length / this.paginate) | 0) +
        (this.speakers.length % this.paginate)
      this.speakersPaginated = []

      for (let i = 0; i < pages; i++) {
        this.speakersPaginated.push(
          (() => {
            let objectsPerPage: any = []

            for (let j = 0; j < this.paginate; j++)
              if (this.speakers.length)
                objectsPerPage.push(this.speakers.shift())

            return {
              array: objectsPerPage
            }
          })()
        )
      }
    }
  }
}
